import { Button } from '@avanta/shared/components/ui/Button';
import { APPOINTMENT_REMOTE_ID, AppointmentType } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { CalendarPlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { FLOW_MODES, type RecentPsychologist } from 'types/appointments';
import { getUserId } from 'utils/storage';

export const BookButton = ({
  recentPsychologist,
}: {
  recentPsychologist: RecentPsychologist;
}): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const navigate = useNavigate();
  const patientId = getUserId();
  const { psychologist, centerId, center, specialitiesBookable } = recentPsychologist;

  const handleBookAppointment = (): void => {
    const bookedContactMethod =
      centerId === APPOINTMENT_REMOTE_ID ? AppointmentType.Video : AppointmentType.InPerson;
    const state = {
      patientId,
      appointment: {
        specialitiesBookable,
        center,
        bookedContactMethod,
      },
      psychologist,
      flow: FLOW_MODES.recent_psychologist,
    };

    navigate(ROUTES.APPOINTMENTS_RESERVE, { state });
  };

  return (
    <Button variant="secondary" className="w-44" onClick={handleBookAppointment} icon="leading">
      <CalendarPlusIcon className="size-4" />
      {t('AppointmentsReserve.cta')}
    </Button>
  );
};
